import { isEmpty } from 'remeda'
import { SuggestedHorizontalProduct } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProduct'
import type { MatchingProduct, Variant } from '@velasca/types'
import { getProductCardImage } from '@velasca/utils/get-product-card-image'
import * as S from './MatchingProductsSection.styles'

export const MatchingProductsSection = ({
  products,
  title,
}: {
  products: MatchingProduct[]
  title: string | undefined
}) => {
  if (isEmpty(products)) {
    return null
  }

  if (!title) {
    return null
  }

  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      <S.ProductsContainer>
        {products.map((product) => {
          const images = product.images?.map((img) => img.src) ?? []
          const variant: Variant = {
            id: product.sizes?.[0]?.id ?? '',
            handle: product.handle,
            description: product.description,
            img: getProductCardImage({
              images,
              customProductType: Number(product.customProductType),
              frontImageIndex: Number(product.frontImageIndex),
              hoverImageIndex: Number(product.hoverImageIndex),
            }),
            price: product.price,
            compareAtPrice: product.compareAtPrice,
            material_desc_tag: product.material
              ? { value: product.material }
              : undefined,
            color_desc_tag: product.color
              ? { value: product.color }
              : undefined,
            sole_tag: product.sole ? { value: product.sole } : undefined,
          }

          return (
            <SuggestedHorizontalProduct
              shouldOpenCartDrawerOnAddToCart
              isQuickAdd
              productType={product.productType}
              customProductType={product.customProductType}
              key={product.id}
              isGiftCard={product.isGiftCard}
              title={product.title}
              variant={variant}
              sizes={product.sizes}
              loading={false}
            />
          )
        })}
      </S.ProductsContainer>
    </S.Container>
  )
}
